module.exports = __webpack_public_path__ + "img/REVOLUTION__1_-removebg-preview-p-800.9d8c623c.png";